import React, { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';
import WidthContainer from '../../../WidthContainer';
import {
  BodyLarge,
  Heading1Text,
  ParagraphLargeText,
  TitleLarge,
} from '../../../Texts';
import Line from '../../../Line';

const InnerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const InnerContainerLeft = styled.div`
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    width: 100%;
    margin-bottom: 50px;
  }
`;

const Container = styled.div`
  min-height: 800px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    flex-direction: column;
    padding: 40px 0px;
  }
`;

const ColorizedSpan = styled.span`
  background-image: linear-gradient(
    90deg,
    ${({ theme }) => theme.text.title} 0%,
    ${({ theme }) => theme.special.purple} 30%,
    ${({ theme }) => theme.primary.primary} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const StepsImageContainer = styled.div`
  width: 100%;
  max-width: 448px;

  img {
    width: 100%;
    height: auto;
  }

  @media ${PHONE_MEDIA_QUERY} {
    max-width: 100%;
    padding: 0 20px;
  }
`;

const Item = styled.div`
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.primary.background};
`;

const StyledTitleLarge = styled(TitleLarge)`
  font-weight: 600;
`;

const Question = ({ question, answer }) => {
  const [isOpened, setIsOpened] = useState(false);
  const theme = useTheme();
  return (
    <Item
      onClick={() => {
        setIsOpened(!isOpened);
      }}
    >
      <StyledTitleLarge>{question}</StyledTitleLarge>
      {isOpened && <BodyLarge>{answer}</BodyLarge>}
    </Item>
  );
};

const GotAnyQuestion = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        backgroundColor: 'white',
      }}
    >
      <WidthContainer>
        <Container>
          <InnerContainerLeft>
            <Heading1Text style={{ color: theme.text.title, width: '100%' }}>
              Got Any <ColorizedSpan>Question?</ColorizedSpan>
            </Heading1Text>
          </InnerContainerLeft>
          <InnerContainer
            style={{
              gap: 40,
            }}
          >
            <Question
              question={'Does the project pay anything to join?'}
              answer={
                'No. Listing and setup are free for the first 25 projects, then $500.'
              }
            />
            <Question
              question={'Can I track my referrals?'}
              answer={
                "Yes—every link is tracked, and you'll receive regular reports."
              }
            />
            <Question
              question={'How long do I earn commission?'}
              answer={'12 full months from the date of project activation.'}
            />
          </InnerContainer>
        </Container>
      </WidthContainer>
    </div>
  );
};

export default GotAnyQuestion;
